/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface MemberFinancialLoanDetailInput { 
    id?: number;
    loanProductName?: string | null;
    loanProductId: number;
    amount: number;
    noOfInstallments?: number;
    totalInterestAmount?: number | null;
    principalAmountPaid?: number | null;
    interestAmountPaid?: number | null;
    loanDisbursementDate?: string | null;
    loanExpireDate?: string | null;
    loanReferenceNumber?: string | null;
    hasDisbursed?: boolean;
}

